(function () {
  'use strict';
  if (window.parityProductShowcase) return;
  window.parityProductShowcase = true;
  var disclosureSelector = '[data-product-showcase]';
  var disclosureDuration = 520;
  var disclosureEasing = 'cubic-bezier(.16, 1, .3, 1)';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function resetDisclosureAnimation(disclosure, panel) {
    window.clearTimeout(disclosure._productShowcaseDisclosureTimer);
    window.cancelAnimationFrame(disclosure._productShowcaseDisclosureFrame);
    disclosure._productShowcaseDisclosureTimer = 0;
    disclosure._productShowcaseDisclosureFrame = 0;

    if (disclosure._productShowcaseDisclosureTransitionEnd) {
      panel.removeEventListener('transitionend', disclosure._productShowcaseDisclosureTransitionEnd);
      disclosure._productShowcaseDisclosureTransitionEnd = null;
    }

    panel.style.removeProperty('height');
    panel.style.removeProperty('overflow');
    panel.style.removeProperty('transition');
    panel.style.removeProperty('will-change');
  }

  function requestSceneUpdate(disclosure) {
    disclosure.dispatchEvent(new CustomEvent('showcase:expanded', { bubbles: true }));
  }

  function setDisclosureExpanded(disclosure, expanded, animate) {
    var trigger = disclosure.querySelector('[data-showcase-trigger]');
    var panel = disclosure.querySelector('[data-showcase-panel]');
    if (!trigger || !panel || disclosure.dataset.productShowcaseDisclosureAnimating === 'true') return;

    if (!expanded && panel.contains(document.activeElement)) trigger.focus({ preventScroll: true });
    resetDisclosureAnimation(disclosure, panel);
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    disclosure.classList.toggle('is-opening', expanded);
    disclosure.classList.toggle('is-closing', !expanded);
    disclosure.classList.toggle('is-expanded', expanded);

    function finish() {
      resetDisclosureAnimation(disclosure, panel);
      disclosure.classList.remove('is-opening', 'is-closing');
      delete disclosure.dataset.productShowcaseDisclosureAnimating;

      if (expanded) {
        panel.removeAttribute('aria-hidden');
        requestSceneUpdate(disclosure);
      } else {
        disclosure.open = false;
        panel.setAttribute('aria-hidden', 'true');
      }
    }

    if (expanded) {
      disclosure.open = true;
      panel.removeAttribute('aria-hidden');
    }

    if (!animate || reducedMotion.matches) {
      finish();
      return;
    }

    disclosure.dataset.productShowcaseDisclosureAnimating = 'true';
    panel.style.overflow = 'hidden';
    panel.style.willChange = 'height';
    panel.style.transition = 'none';
    panel.style.height = (expanded ? 0 : panel.getBoundingClientRect().height) + 'px';
    void panel.offsetHeight;

    disclosure._productShowcaseDisclosureTransitionEnd = function (event) {
      if (event.target !== panel || event.propertyName !== 'height') return;
      finish();
    };
    panel.addEventListener('transitionend', disclosure._productShowcaseDisclosureTransitionEnd);

    disclosure._productShowcaseDisclosureFrame = window.requestAnimationFrame(function () {
      disclosure._productShowcaseDisclosureFrame = 0;
      panel.style.transition = 'height ' + disclosureDuration + 'ms ' + disclosureEasing;
      panel.style.height = (expanded ? panel.scrollHeight : 0) + 'px';
    });

    disclosure._productShowcaseDisclosureTimer = window.setTimeout(finish, disclosureDuration + 100);
  }

  function initDisclosure(disclosure) {
    if (!disclosure || disclosure.dataset.productShowcaseDisclosureReady === 'true') return;

    var trigger = disclosure.querySelector('[data-showcase-trigger]');
    var panel = disclosure.querySelector('[data-showcase-panel]');
    if (!trigger || !panel) return;

    function onToggle(event) {
      event.preventDefault();
      setDisclosureExpanded(disclosure, !disclosure.open, true);
    }

    trigger.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
    disclosure.classList.toggle('is-expanded', disclosure.open);
    if (disclosure.open) {
      panel.removeAttribute('aria-hidden');
    } else {
      panel.setAttribute('aria-hidden', 'true');
    }

    trigger.addEventListener('click', onToggle);
    disclosure._productShowcaseDisclosureCleanup = function () {
      trigger.removeEventListener('click', onToggle);
      resetDisclosureAnimation(disclosure, panel);
      disclosure.classList.remove('is-opening', 'is-closing');
      delete disclosure.dataset.productShowcaseDisclosureAnimating;
      delete disclosure.dataset.productShowcaseDisclosureReady;
      delete disclosure._productShowcaseDisclosureCleanup;
    };
    disclosure.dataset.productShowcaseDisclosureReady = 'true';
  }

  function initGallery(gallery) {
    if (gallery.showcaseSelect) return;
    function owned(selector) {
      return Array.from(gallery.querySelectorAll(selector)).filter(function (node) { return node.closest('[data-showcase-gallery]') === gallery; });
    }
    var slides = owned('[data-showcase-slide]');
    var choices = owned('[data-showcase-option]');
    var links = owned('[data-showcase-link]');
    if (!slides.length) return;
    var active = 0;
    var controller = new AbortController();
    var listenerOptions = { signal: controller.signal };
    var suppressedUntil = 0;
    function select(index, chosen) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, i) {
        slide.hidden = i !== active;
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
      });
      choices.forEach(function (button, i) {
        button.classList.toggle('is-active', i === active);
        button.setAttribute('aria-pressed', i === active ? 'true' : 'false');
      });
      var selected = slides[active];
      owned('[data-showcase-label]').forEach(function (node) { node.textContent = selected.dataset.label || ''; });
      owned('[data-showcase-price]').forEach(function (node) { node.textContent = selected.dataset.price || ''; });
      owned('[data-showcase-status]').forEach(function (node) { node.textContent = selected.dataset.available === 'false' ? 'Currently unavailable' : 'Built to order'; });
      owned('[data-showcase-image-note]').forEach(function (node) { node.hidden = selected.dataset.fallbackImage !== 'true'; });
      owned('[data-showcase-counter]').forEach(function (node) { node.textContent = String(active + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0'); });
      links.forEach(function (link) {
        if (!selected.dataset.url) return;
        link.href = selected.dataset.url;
        link.setAttribute('aria-label', 'Shop ' + (selected.dataset.label || 'selected option'));
      });
      owned('[data-showcase-prev]').forEach(function (button) { button.disabled = active === 0; });
      owned('[data-showcase-next]').forEach(function (button) { button.disabled = active === slides.length - 1; });
      if (chosen) gallery.dispatchEvent(new CustomEvent('showcase:choose', { bubbles: true, detail: { index: active } }));
    }
    gallery.showcaseSelect = select;
    choices.forEach(function (choice, index) { choice.addEventListener('click', function () { select(index, true); }, listenerOptions); });
    owned('[data-showcase-prev]').forEach(function (button) { button.addEventListener('click', function () { select(active - 1, true); }, listenerOptions); });
    owned('[data-showcase-next]').forEach(function (button) { button.addEventListener('click', function () { select(active + 1, true); }, listenerOptions); });
    owned('[data-showcase-swipe]').forEach(function (surface) {
      var start = null;
      surface.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) return;
        start = { id: event.pointerId, x: event.clientX, y: event.clientY };
        surface.setPointerCapture?.(event.pointerId);
      }, listenerOptions);
      surface.addEventListener('pointerup', function (event) {
        if (!start || event.pointerId !== start.id) return;
        var dx = event.clientX - start.x;
        var dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 42 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;
        suppressedUntil = Date.now() + 550;
        select(active + (dx < 0 ? 1 : -1), true);
      }, listenerOptions);
      surface.addEventListener('pointercancel', function () { start = null; }, listenerOptions);
      surface.addEventListener('click', function (event) {
        if (Date.now() < suppressedUntil) { event.preventDefault(); event.stopPropagation(); }
      }, { signal: controller.signal, capture: true });
      surface.addEventListener('dragstart', function (event) { event.preventDefault(); }, listenerOptions);
    });
    gallery._showcaseCleanup = function () { controller.abort(); delete gallery.showcaseSelect; delete gallery._showcaseCleanup; };
    select(0, false);
  }
  function scan(root) {
    root.querySelectorAll(disclosureSelector).forEach(initDisclosure);
    root.querySelectorAll('[data-showcase-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(disclosureSelector).forEach(function (disclosure) { disclosure._productShowcaseDisclosureCleanup?.(); });
    event.target.querySelectorAll('[data-showcase-gallery]').forEach(function (gallery) { gallery._showcaseCleanup?.(); });
  });
})();
